export default {
      id: "ic_in-new-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#ic_in-new",
      toString: function () {
        return this.url;
      }
    }